import { html } from 'lit';

export const iconPdfFilled = html`
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 9.5H2.5V8H2.75C3.15625 8 3.5 8.34375 3.5 8.75C3.5 9.1875 3.15625 9.5 2.75 9.5ZM6 8H6.25C6.5 8 6.75 8.25 6.75 8.5V10.5C6.75 10.7812 6.5 11 6.25 11H6V8ZM7 0V4C7 4.5625 7.4375 5 8 5H12V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2C0 0.90625 0.875 0 2 0H7ZM2 7C1.71875 7 1.5 7.25 1.5 7.5V11.5C1.5 11.7812 1.71875 12 2 12C2.25 12 2.5 11.7812 2.5 11.5V10.5H2.75C3.6875 10.5 4.5 9.71875 4.5 8.75C4.5 7.8125 3.6875 7 2.75 7H2ZM5 11.5C5 11.7812 5.21875 12 5.5 12H6.25C7.0625 12 7.75 11.3438 7.75 10.5V8.5C7.75 7.6875 7.0625 7 6.25 7H5.5C5.21875 7 5 7.25 5 7.5V11.5ZM9 7C8.71875 7 8.5 7.25 8.5 7.5V11.5C8.5 11.7812 8.71875 12 9 12C9.25 12 9.5 11.7812 9.5 11.5V10H10.5C10.75 10 11 9.78125 11 9.5C11 9.25 10.75 9 10.5 9H9.5V8H10.5C10.75 8 11 7.78125 11 7.5C11 7.25 10.75 7 10.5 7H9ZM8 0L12 4H8V0Z"
    />
  </svg>
`;
